import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { SliderInput, Space, Typography } from '@sravni/react-design-system';
import { Controller } from 'react-hook-form';

import { AMOUNT } from '../MfoFullDealForm.constants';

const { Text } = Typography;

const { min, max } = AMOUNT;

export const Amount = (props: IFieldFactoryProps) => {
  const { type, label, ...other } = props;

  return (
    <Space
      size={4}
      direction="vertical"
    >
      <Controller
        name={type}
        {...other}
        render={({ field }) => (
          <SliderInput
            label={label}
            thousandSeparator=" "
            min={min}
            max={max}
            postfix="₽"
            value={Number(field.value)}
            onChange={field.onChange}
            step={1000}
          />
        )}
      />
      <Text
        size={12}
        className="h-color-D60 h-ml-16"
      >
        от {min} до {max} ₽
      </Text>
    </Space>
  );
};
